import TextField from '../shared';
import { Block } from '@/components/crRender';
import i18n from '@/langsconfig/i18n';
import { formatDate, formatTime, formatDateTime, isValidDate } from '@/utils/DateUtils';
import { Validations } from '@/utils/validations';


export const DateValue = ({ value }: { value: string | Date }) =>
  <>
    <Block isRender={isValidDate(value)} children={<TextField value={formatDate(value)} />} />
    <Block isRender={!isValidDate(value)} children={!Validations.isNull( value) ? i18n.t('invalid-date') :"---"} />
  </>

export const TimeValue = ({ value }) =>
  <>
    <Block isRender={isValidDate(value)} children={<TextField value={formatTime(value)} />} />
    <Block isRender={!isValidDate(value)} children={i18n.t('invalid-time')} />
  </>

export const DateTimeValue = ({ value }) =>
  <>
    <Block isRender={isValidDate(value)} children={<TextField value={formatDateTime(value)} />} />
    <Block isRender={!isValidDate(value)} children={i18n.t('invalid-date-time')} />
  </>